export default {
    "ace": "Acehnais",
    "af": "Afrikaans",
    "am": "Amharique",
    "an": "Aragonais",
    "ar": "Arabe",
    "as": "Assamais",
    "ay": "Aymara",
    "az": "Azerbaïdjanais",
    "ba": "Bachkir",
    "be": "Biélorusse",
    "bg": "Bulgare",
    "bho": "Bhojpuri",
    "bn": "Bengali",
    "bo": "Tibétain",
    "br": "Breton",
    "bs": "Bosnien",
    "ca": "Catalan",
    "ceb": "Cebuano",
    "ckb": "Kurde (sorani)",
    "cs": "Tchèque",
    "cy": "Gallois",
    "da": "Danois",
    "de": "Allemand",
    "de-ch": "Allemand (suisse)",
    "de-de": "Allemand (Allemagne)",
    "el": "Grec",
    "en": "Anglais",
    "en-gb": "Anglais (britannique)",
    "en-us": "Anglais (américain)",
    "eo": "Espéranto",
    "es": "Espagnol",
    "es-419": "Espagnol (d'Amérique latine)",
    "et": "Estonien",
    "eu": "Basque",
    "fa": "Persan",
    "fi": "Finnois",
    "fo": "Féroïen",
    "fr": "Français",
    "fr-ca": "Français (canadien)",
    "fr-fr": "Français (France)",
    "ga": "Irlandais",
    "gl": "Galicien",
    "gn": "Guarani",
    "gom": "Konkani",
    "gu": "Gujarati",
    "ha": "Haoussa",
    "haw": "Hawaïen",
    "he": "Hébreu",
    "hi": "Hindi",
    "hr": "Croate",
    "ht": "Créole haïtien",
    "hu": "Hongrois",
    "hy": "Arménien",
    "id": "Indonésien",
    "ig": "Igbo",
    "is": "Islandais",
    "it": "Italien",
    "ja": "Japonais",
    "jv": "Javanais",
    "ka": "Géorgien",
    "kk": "Kazakh",
    "km": "Khmer",
    "kmr": "Kurde (kurmanji)",
    "kn": "Kannada",
    "ko": "Coréen",
    "ky": "Kirghize",
    "la": "Latin",
    "lb": "Luxembourgeois",
    "lmo": "Lombard",
    "ln": "Lingala",
    "lo": "Laotien",
    "lt": "Lituanien",
    "lv": "Letton",
    "mai": "Maithili",
    "mg": "Malgache",
    "mi": "Maori",
    "mk": "Macédonien",
    "ml": "Malayalam",
    "mn": "Mongol",
    "mr": "Marathi",
    "ms": "Malais",
    "mt": "Maltais",
    "my": "Birman",
    "nb": "Norvégien (bokmål)",
    "ne": "Népalais",
    "nl": "Néerlandais",
    "nn": "Norvégien (nynorsk)",
    "no": "Norvégien",
    "oc": "Occitan",
    "om": "Oromo",
    "pa": "Pendjabi",
    "pag": "Pangasinan",
    "pam": "Kapampangan",
    "pl": "Polonais",
    "prs": "Dari",
    "ps": "Pashto",
    "pt": "Portugais",
    "pt-br": "Portugais (brésilien)",
    "pt-pt": "Portugais (européen)",
    "qu": "Quechua",
    "ro": "Roumain",
    "ru": "Russe",
    "sa": "Sanskrit",
    "scn": "Sicilien",
    "sd": "Sindhi",
    "si": "Cinghalais",
    "sk": "Slovaque",
    "sl": "Slovène",
    "sn": "Shona",
    "so": "Somali",
    "sq": "Albanais",
    "sr": "Serbe",
    "st": "Sotho du Sud",
    "su": "Soudanais",
    "sv": "Suédois",
    "sw": "Swahili",
    "ta": "Tamoul",
    "te": "Télougou",
    "tg": "Tadjik",
    "th": "Thaï",
    "tk": "Turkmène",
    "tl": "Tagalog",
    "tn": "Tswana",
    "tr": "Turc",
    "ts": "Tsonga",
    "tt": "Tatar",
    "uk": "Ukrainien",
    "ur": "Urdu",
    "uz": "Ouzbek",
    "vi": "Vietnamien",
    "wo": "Wolof",
    "xh": "Xhosa",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "yue": "Cantonais",
    "zh": "Chinois",
    "zh-hans": "Chinois (simplifié)",
    "zh-hant": "Chinois (traditionnel)",
    "zu": "Zoulou"
}